import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { TextBox } from "@progress/kendo-react-inputs";

import "./notification.css";
export const SearchEmailTemplate = (props) => {
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const [searchSubject, setSearchSubject] = useState(null);

  useEffect(() => {
    if (query.get("subject")) {
      setSearchSubject(query.get("subject"));
    }
  }, []);
  const onhandleSearch = () => {
    const data = {
      subject: searchSubject ? searchSubject : "",
    };
    console.log(data);
    props.onSearchcallback(data);
  };
  const handleSearchSubject = (e) => {
    setSearchSubject(e.target.value);
  };
  return (
    <>
      <Dialog
        className="search-notification"
        title={" "}
        // width={500}
        height={"100%"}
        onClose={() => props.setShowSearchDialog(false)}
      >
        <div className="search-body">
          <div className="noti-dialog-title dialog-row">Search</div>
          <div className="dialog-row">
            <span className="search-row-title">By subject</span>
            <TextBox
              className="search-input"
              value={searchSubject}
              onChange={handleSearchSubject}
              suffix={() => (
                <Button
                  className="clear-button-dialog"
                  onClick={() => setSearchSubject("")}
                >
                  X
                </Button>
              )}
            />
          </div>
        </div>
        <DialogActionsBar>
          <Button
            className="search-button cancel-btn"
            onClick={() => props.setShowSearchDialog(false)}
          >
            Cancel
          </Button>
          <Button className="search-button search-btn" onClick={onhandleSearch}>
            Submit
          </Button>
        </DialogActionsBar>
      </Dialog>
    </>
  );
};
